// Phase 2.1 Lite — Shared V2 template config map.
// Used by PublicInvite, InternalTemplatePreviewPage, and PublicDemoPage so
// the same config registry doesn't drift across three files.
//
// Add a new template config in ONE place: here.

import { elegantWeddingV1 } from '../templates/elegant-wedding-v1';
import { noirVinylV1 } from '../templates/noir-vinyl-v1';
import { timelessEleganceV1 } from '../templates/timeless-elegance-v1';
import { modernMinimalV1 } from '../templates/modern-minimal-v1';
import { editorialRomanceV1 } from '../templates/editorial-romance-v1';
import { eveningLuxeV1 } from '../templates/evening-luxe-v1';
import { memoryCollageV1 } from '../templates/memory-collage-v1';
import { oceanEditorialCollageV1 } from '../templates/ocean-editorial-collage-v1';
import { freeformStudioV1 } from '../templates/freeform-studio-v1';

export const V2_TEMPLATES = {
  'elegant-wedding-v1': elegantWeddingV1,
  'noir-vinyl-v1': noirVinylV1,
  'timeless-elegance-v1': timelessEleganceV1,
  'modern-minimal-v1': modernMinimalV1,
  'editorial-romance-v1': editorialRomanceV1,
  'evening-luxe-v1': eveningLuxeV1,
  'memory-collage-v1': memoryCollageV1,
  'ocean-editorial-collage-v1': oceanEditorialCollageV1,
  'freeform-studio-v1': freeformStudioV1,
};

export const DEFAULT_V2_TEMPLATE_ID = 'freeform-studio-v1';
